module.exports = "/assets/career/team/kasia_przybysz.png?aai30j+";